<template>
  <v-container fluid grid-list-md>
    <v-card
      class="mt-2 mx-auto rounded"
      max-width="800"
      color="white"
      elevation-20
    >
      <center>
        <img
          class="mt-3 mb-3 hidden-md-and-up"
          src="@/assets/img/logo-md.png"
          style="max-width=200px;"
        />
        <img
          class="mt-3 mb-3 hidden-sm-and-down"
          src="@/assets/img/logo-md.png"
          style="max-width=400px;"
        />
      </center>

      <v-sheet
        class="py-4 ml-3"
        color="amber darken-1"
        max-width="calc(100% - 32px)"
      >
        <h1
          class="display-2 text-xs-center font-weight-bold condensed white--text"
        >
          403: Forbidden
        </h1>
      </v-sheet>

      <v-card-text class="pl-4 mt-2">
        <div class="headline mb-2">Hey now, wait a minute here.</div>
        <div class="subheading font-weight-light">
          Your request is forbidden.
        </div>
        <v-divider class="my-2"></v-divider>
        <v-icon class="mr-2" small>
          alarm
        </v-icon>
        <span class="text-right font-weight-light"
          >{{ new Date().toLocaleDateString() }}
          {{ new Date().toLocaleTimeString() }}</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- back -->
        <v-btn
          @click="$router.go(-1)"
          small
          color="blue-grey lighten-3"
          round
          dark
          elevation-4
          class="black--text"
          >Back</v-btn
        >
        <!-- home -->
        <v-btn
          v-if="isLoggedIn"
          @click="$router.push({ name: 'home' })"
          small
          color="primary"
          round
          dark
          elevation-4
          class="white--text"
          >Home</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Forbidden',
  computed: {
    ...mapGetters(['isLoggedIn'])
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  img {
    max-width: 200px;
  }
  h1 {
    font-size: 12px;
  }
}
</style>
